import { useState } from 'react';
import api from '../services/api';
import SEO from '../components/SEO';

const ForgotPasswordPage = ({ switchToLogin }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setStatus('');
    try {
      const res = await api.post('/auth/forgot-password', { email });
      setStatus(res.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <SEO title="Forgot Password" description="Recover your Study Centro account password." />
      <div className="auth-card">
        <h1>Forgot Password</h1>
        <p>Enter your email address and we'll send you a link to reset your password.</p>
        
        {status && <div className="status-message">{status}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="name@example.com"
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <div className="auth-footer">
          Remember your password? <button onClick={switchToLogin} className="link-button">Login</button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
